<!--
 * @Author: your name
 * @Date: 2020-08-13 20:29:51
 * @LastEditTime: 2022-12-07 16:06:31
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/pay/component/Items/index.vue
-->
<style scoped lang="sass">
.items
  flex-shrink: 0
  display: flex
  justify-content: space-between
  padding: 14px 0
  border-bottom: 1px solid #f1f2f3
  min-height: 68px
  padding-left: 17px
  padding-right: 17px

  .left
    padding-right: 9px
    font-size: 13px
    line-height: 16px
    color: var(--menu-primary-text-colour) !important

  .mid
    flex: 1
    display: flex
    flex-direction: column

    .title
      font-size: 13px
      color: var(--menu-primary-text-colour) !important

    .combo_item
      margin-top: 6px

  .right
    display: flex
    justify-content: space-between
    flex-direction: column
    font-size: 12px
    color: var(--menu-primary-text-colour) !important

    .money
      text-align: right

.normal_font
  line-height: 17px

.side_dish_box
  font-size: 12px
  color: var(--menu-primary-text-colour)

  .side_dish_title
    line-height: 16px

  .side_dish
    font-size: 12px
    font-weight: 400
    line-height: 21px

  .side_dish_text
    display: flex
    flex-wrap: wrap

    .side_dish_add
      margin-right: 2px
      line-height: 21px

.station_status
  margin-top: 6px
  font-size: 12px
  color: var(--menu-primary-text-colour)
  display: flex
  flex-direction: row
  flex-wrap: nowrap
  align-content: center
  align-items: center

  .station_status_label
    font-weight: 500
    margin-right: 5px

  .station_status_text
    width: 69px
    height: 23px
    border-radius: 12px
    text-align: center
    font: normal normal bold 12px/16px Roboto
    letter-spacing: -0.45px
    color: #FFFFFF
    display: flex
    flex-wrap: nowrap
    align-content: center
    justify-content: center
    align-items: center

    &.preparing
      background-color: #FFCE00

    &.served
      background-color: #46D666

    &.no_status
      background-color: rgba(51, 68, 85, 0.51)
</style>

<template lang="pug">
.items
  .left.b {{ data.no }}
  .mid(v-if="data.type !== 'combo'")
    OrderItemsContent(:data="data")
    .station_status(v-if="hasStation")
      strong.station_status_label {{ t('status', 'Status:') }}
      small.station_status_text(:class="stationStatusClass") {{ stationStatusText }}
  .mid(v-else)
    .title.b {{ localizedComboName }}
    div(v-for="(combo, index) in data.comboProducts" :key="index")
      div(v-for="(item, itemIndex) in combo.itemList" :key="itemIndex")
        OrderItemsContent.o(:data="item")

    .side_dish_box.o5(v-if="sideDish.optionalList.length > 0 || sideDish.remove.length > 0 || sideDish.requiredList.length > 0")
      .side_dish_title {{ t('combo_modifications', 'Combo Modifications:') }}
      .side_dish_text(v-if="sideDish.requiredList.length > 0")
        .side_dish(v-for="(item, index) in sideDish.requiredList") {{ index !== 0 ? ',' : '' }} {{ getLocalizedItemName(item) }}{{ item.no > 1 ? ' x' + item.no : '' }}

      .side_dish_text(v-if="sideDish.optionalList.length > 0")
        .side_dish_add {{ t('add_label', 'Add:') }}
        .side_dish(v-for="(item, index) in sideDish.optionalList") {{ index !== 0 ? ',' : '' }} {{ getLocalizedItemName(item) }}{{ item.no > 1 ? ' x' + item.no : '' }}

      .side_dish_text(v-if="sideDish.remove.length > 0")
        .side_dish_add {{ t('remove_label', 'Remove:') }}
        .side_dish(v-for="(item, index) in sideDish.remove") {{ index !== 0 ? ',' : '' }} {{ getLocalizedItemName(item) }}{{ item.no > 1 ? ' x' + item.no : '' }}
    .station_status(v-if="hasStation")
      strong.station_status_label {{ t('status', 'Status:') }}
      small.station_status_text(:class="stationStatusClass") {{ stationStatusText }}
  .right
    .money.o(v-if="showMoney") {{ symbolPosition === 'after' ? '' : currencySymbol }}{{ data.discountAmount ? parseFloat(data.discountAmount) + parseFloat(data.amount) : data.amount | fix }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}
    status(v-if="isPostPaid && $route.name === 'pay'" :number="data.status")
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import Status from './../Status'
import OrderItemsContent from '../ItemContent'
import { formatDecimalNumber, getCurrencySymbol, getSymbolPosition } from '@/utils/currency'
import { getLocalizedField, t } from '@/utils/language'

@Component({
  filters: {
    fix(val) {
      return val ? formatDecimalNumber(parseFloat(val)) : 0
    }
  },

  props: {
    data: Object,
    isPostPaid: Boolean,
    showMoney: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    currentLanguage() {
      return this.$store.state.language?.currentLanguage
    },

    // Add all the modifications in data to an array and return a new array with all the modifications
    // 把 data 中的配菜都添加到一个数组中，返回一个新的带有所有配菜的数组
    sideDish() {
      const data = this.data
      const sideDishList = {
        requiredList: [],
        remove: [],
        optionalList: []
      }
      data.addList.forEach(item => {
        item.items.forEach(ls => {
          if (item.type === 'optional') {
            sideDishList.optionalList.push(ls)
          } else {
            sideDishList.requiredList.push(ls)
          }
        })
      })
      data.removeList.forEach(item => {
        item.items.forEach(ls => {
          sideDishList.remove.push(ls)
        })
      })

      return sideDishList
    },

    /**
     * Whether the item has a station and should show status
     * 判断item是否有station且应显示状态（只在item为preparing状态下显示）
     * @returns {Boolean}
     */
    hasStation() {
      const station = this.data.station
      const itemStatus = this.data.status
      // Only show station status when item is in preparing state (status 0 or 1)
      // 只在item为preparing状态（status为0或1）时显示station状态
      const isPreparing = itemStatus === 0 || itemStatus === 1
      return !!(station && typeof station === 'object' && station.id && isPreparing)
    },

    /**
     * Get status text based on item status
     * 根据item的status获取状态文本
     * @returns {String}
     */
    stationStatusText() {
      const status = this.data.status
      if (status === 0) {
        return t('preparing', 'Preparing')
      } else if (status === 1) {
        return t('ready', 'Ready')
      } else {
        return t('pending', 'Pending')
      }
    },

    /**
     * Get status CSS class based on item status
     * 根据item的status获取状态样式类
     * @returns {String}
     */
    stationStatusClass() {
      const status = this.data.status
      if (status === 0) {
        return 'preparing'
      } else if (status === 1) {
        return 'served'
      } else {
        return 'no_status'
      }
    },

    currencySymbol() {
      const _c = this.$currencyCode // eslint-disable-line no-unused-vars
      return getCurrencySymbol()
    },

    symbolPosition() {
      const _c = this.$currencyCode // eslint-disable-line no-unused-vars
      return getSymbolPosition()
    }
  },

  components: {
    Status,
    OrderItemsContent
  },
})
class Items extends Vue {
  // Get localized combo name / 获取本地化的套餐名称
  get localizedComboName() {
    const _lang = this.currentLanguage // eslint-disable-line no-unused-vars
    return this.data.upgradeProductName || getLocalizedField(this.data, 'name') || this.data.name
  }

  // Translation helper / 翻译辅助函数
  t(key, fallback) {
    const _lang = this.$lang // eslint-disable-line no-unused-vars
    return t(key, fallback)
  }

  // Get localized item name / 获取本地化的项目名称
  getLocalizedItemName(item) {
    const _lang = this.currentLanguage // eslint-disable-line no-unused-vars
    return getLocalizedField(item, 'name') || item.name
  }

  // Returns the corresponding string according to num
  // 根据 num 返回对应字符串
  isAdd(num) {
    const price = parseFloat(num)
    return price > 0 ? t('add_label', 'Add:') : t('remove_label', 'Remove:')
  }
}

export default Items
</script>
